"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermissionOnFormPayment = exports.canReceiveVisitorReport = exports.hasPermissionOnTapToPay = exports.hasPermissionOnBank = exports.hasPermissionOnContacts = exports.hasPermissionOnUserManagement = exports.hasPermissionOnAllReceipts = exports.hasPermissionOnAllPayments = exports.hasPermissionOnAllEditForms = exports.hasPermissionOnAtLeastOneFormReceipt = exports.hasPermissionOnAtLeastOneFormPayment = exports.hasPermissionOnAtLeastOneForm = exports.mapNewPermissionsToOldPermissions = exports.getAllGeneralPermissions = void 0;
const user_1 = require("./user");
const getAllGeneralPermissions = () => Object.values(user_1.UserGeneralPermissions);
exports.getAllGeneralPermissions = getAllGeneralPermissions;
const mapNewPermissionsToOldPermissions = (params) => {
    const generalPermissions = params.generalPermissions ?? [];
    const formPermissions = params.formPermissions ?? [];
    const result = [];
    if (generalPermissions.includes(user_1.UserGeneralPermissions.Contacts)) {
        result.push(user_1.UserPermissions.Contacts);
    }
    if (generalPermissions.includes(user_1.UserGeneralPermissions.Bank)) {
        result.push(user_1.UserPermissions.Bank);
    }
    if (formPermissions.includes(user_1.UserFormPermissions.TapToPayPayments)) {
        result.push(user_1.UserPermissions.TapToPay);
    }
    if (generalPermissions.includes(user_1.UserGeneralPermissions.UserManagement)) {
        result.push(user_1.UserPermissions.UserManagement);
    }
    if (formPermissions.includes(user_1.UserFormPermissions.EditForm)) {
        result.push(user_1.UserPermissions.Donation);
        result.push(user_1.UserPermissions.Ticketing);
    }
    if (formPermissions.includes(user_1.UserFormPermissions.Receipt)) {
        result.push(user_1.UserPermissions.Receipt);
    }
    return result;
};
exports.mapNewPermissionsToOldPermissions = mapNewPermissionsToOldPermissions;
const hasPermissionOnAtLeastOneForm = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.EditForm));
};
exports.hasPermissionOnAtLeastOneForm = hasPermissionOnAtLeastOneForm;
const hasPermissionOnAtLeastOneFormPayment = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.ManagePayments));
};
exports.hasPermissionOnAtLeastOneFormPayment = hasPermissionOnAtLeastOneFormPayment;
const hasPermissionOnAtLeastOneFormReceipt = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.Receipt));
};
exports.hasPermissionOnAtLeastOneFormReceipt = hasPermissionOnAtLeastOneFormReceipt;
const hasPermissionOnAllEditForms = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.EditForm)) &&
        !newFormPermissions?.permissionFormIds.length);
};
exports.hasPermissionOnAllEditForms = hasPermissionOnAllEditForms;
const hasPermissionOnAllPayments = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.ManagePayments)) &&
        !newFormPermissions?.permissionFormIds.length);
};
exports.hasPermissionOnAllPayments = hasPermissionOnAllPayments;
const hasPermissionOnAllReceipts = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.Receipt)) &&
        !newFormPermissions?.permissionFormIds.length);
};
exports.hasPermissionOnAllReceipts = hasPermissionOnAllReceipts;
const hasPermissionOnUserManagement = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(user_1.UserGeneralPermissions.UserManagement));
};
exports.hasPermissionOnUserManagement = hasPermissionOnUserManagement;
const hasPermissionOnContacts = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(user_1.UserGeneralPermissions.Contacts));
};
exports.hasPermissionOnContacts = hasPermissionOnContacts;
const hasPermissionOnBank = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(user_1.UserGeneralPermissions.Bank));
};
exports.hasPermissionOnBank = hasPermissionOnBank;
const hasPermissionOnTapToPay = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.TapToPayPayments));
};
exports.hasPermissionOnTapToPay = hasPermissionOnTapToPay;
const canReceiveVisitorReport = ({ role, formPermissions, permissionFormIds, }) => {
    if (role === user_1.UserRoles.Owner) {
        return true;
    }
    return Boolean(formPermissions?.includes(user_1.UserFormPermissions.ManagePayments)) && !permissionFormIds?.length;
};
exports.canReceiveVisitorReport = canReceiveVisitorReport;
const hasPermissionOnFormPayment = ({ newFormPermissions, formId, }) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(user_1.UserFormPermissions.ManagePayments)) &&
        (!newFormPermissions?.permissionFormIds.length || newFormPermissions?.permissionFormIds.includes(formId)));
};
exports.hasPermissionOnFormPayment = hasPermissionOnFormPayment;
